export default __webpack_public_path__ + "static/media/GVL_University_Long.f90a7ab9.png";